import { createAction, props } from '@ngrx/store';
import { Review } from '../../models';

export const LoadReviews = createAction('[Places Api] Load Review Data');
export const LoadReviewsSuccess = createAction(
  '[Places Api] Load Review Data Success',
  props<{ reviewData: { rating: number; count: number; reviews: Review[] } }>()
);
export const LoadReviewsFail = createAction('[Places Api] Load Review Data Fail', props<{ error: any }>());
